import React from 'react'
import PropTypes from 'prop-types'

// Components
import NavBeforeIcon from 'fc-icons/src/NavigateBefore'
import NavAfterIcon from 'fc-icons/src/NavigateAfter'
import NavFirstIcon from 'fc-icons/src/NavigateFirst'
import NavLastIcon from 'fc-icons/src/NavigateLast'

// Styles
import { paginatorStyle } from './styles'

export const Paginator = ({
  page = 0,
  pages = [0],
  start = 1,
  end = 14,
  max = 0,
  onPaginateLeft,
  onPaginateRight,
  onPaginateFirst,
  onPaginateLast,
}) => (
  <ul style={paginatorStyle}>
    <li onClick={onPaginateFirst}>
      <NavFirstIcon size={24} />
    </li>
    <li onClick={onPaginateLeft}>
      <NavBeforeIcon size={24} />
    </li>
    <li>
      <span style={{
        whiteSpace: 'nowrap',
      }}>
        <span>{start}</span>
        <span>{' - '}</span>
        <span>{end}</span>
        <span>{' of '}</span>
        <span>{max}</span>
      </span>
    </li>
    <li onClick={onPaginateRight}>
      <NavAfterIcon size={24} />
    </li>
    <li onClick={onPaginateLast}>
      <NavLastIcon size={24} />
    </li>
  </ul>
)

Paginator.propTypes = {
  page: PropTypes.number,
  pages: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
  start: PropTypes.number,
  end: PropTypes.number,
  max: PropTypes.number,
  onPaginateLeft: PropTypes.func,
  onPaginateRight: PropTypes.func,
  onPaginateFirst: PropTypes.func,
  onPaginateLast: PropTypes.func,
}

export default Paginator
